/** Rows for the altitude profile and the chart-hover → map-point mapping (spec §6.5). */
import { dist, frameAround, toLocal, toWgs } from '@/planner/frame';
import type { LngLat, Profile, Waypoint } from '@/planner/types';

/** Height above takeoff and, where the ground is known, above ground. */
export function profileRows(profile: Profile): { d: number; relative: number; clearance: number | null }[] {
  return profile.distance_m.map((d, i) => {
    const terrain = profile.terrain_m?.[i] ?? null;
    const relative = profile.flight_m[i];
    return { d, relative, clearance: terrain === null ? null : relative - terrain };
  });
}

/** The point `distance_m` along the waypoint path (the profile's x axis); clamped to the ends. */
export function pointAlongPath(waypoints: Waypoint[], distance_m: number): LngLat | null {
  if (waypoints.length === 0) return null;
  const lls: LngLat[] = waypoints.map((w) => [w.lng, w.lat]);
  const f = frameAround(lls);
  const pts = lls.map((p) => toLocal(f, p));
  let left = Math.max(0, distance_m);
  for (let i = 1; i < pts.length; i++) {
    const seg = dist(pts[i - 1], pts[i]);
    if (left <= seg) {
      const t = seg === 0 ? 0 : left / seg;
      return toWgs(f, { x: pts[i - 1].x + (pts[i].x - pts[i - 1].x) * t, y: pts[i - 1].y + (pts[i].y - pts[i - 1].y) * t });
    }
    left -= seg;
  }
  return lls[lls.length - 1];
}
